// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"11da5fe0","455":"28bf3b8e","977":"b2620277"}[chunkId] + ".chunk.js";
};